import { render, staticRenderFns } from "./Detail-User.vue?vue&type=template&id=08c91af6"
import script from "./Detail-User.vue?vue&type=script&lang=js"
export * from "./Detail-User.vue?vue&type=script&lang=js"
import style0 from "./Detail-User.vue?vue&type=style&index=0&id=08c91af6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports